import React from 'react';

interface UnsavedChangesDotProps {
  visible: boolean;
}

export const UnsavedChangesDot: React.FC<UnsavedChangesDotProps> = ({
  visible
}) => {
  if (!visible) return null;
  
  return (
    <div 
      className="w-2 h-2 rounded-full bg-blue-500 ml-2" 
      title="Unsaved changes"
    />
  );
}; 